<template>
  <component v-bind:is="component" />
</template>

<script>

import BankSlip from './BankSlip'
import ScheduledDebit from './ScheduledDebit'
import Pix from './Pix'

export default {
  name: 'NonInstantPaymentsIndex',
  components: {
    BankSlip,
    ScheduledDebit,
    Pix
  },
  computed: {
    component () {
      return this.handleTypePayment(this.$store.state.payment.typePayment)
    }
  },
  methods: {
    handleTypePayment (type) {
      return type.split('_').map((el) => {
        return el.charAt(0).toUpperCase() + el.slice(1).toLowerCase()
      }).join('')
    }
  }
}
</script>

<style lang="scss">
  @import "~@/style/ui/variables";

  .barCode {
    display: none;
  }

  .pageSuccess {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #f1f4f9;
    padding: 32px 12px 0 12px;

    &__text {
      &--title {
        font-size: 24px;
        margin: 0 0 32px;
      }
    }

    &__description {
      text-align: center;
      max-width: 750px;
      margin: auto auto 40px;

      p:last-child {
        margin-top: 32px;
      }
    }

    &__quotationDetails {
      border: 1px solid rgba(189, 194, 198, 0.4);
      border-radius: 8px;
      border-top-left-radius: initial;
      border-top-right-radius: initial;
      border-top-color: transparent;
      background: #FFFFFF;
      position: relative;
      bottom: calc(16px + 28px);
      max-width: 945px;
      padding: 0 0px 32px;
      margin: 0 auto 16px;
      width: 100%;
    }

    &__blockDescription {
      position: relative;
      border: 1px solid rgba(189, 194, 198, 0.4);
      border-radius: 8px;
      background: #FFFFFF;
      padding: 24px 16px;
      margin: 0 auto 16px;
      max-width: 945px;
      overflow: hidden;
      width: 100%;

      @media screen and (min-width: 768px) {
        padding: 24px;
      }

      @media screen and (min-width: 1024px) {
        padding: 24px 32px;
      }

      .copyBarCode {
        position: absolute;
        right: 5px;
        top: 5px;
        padding: 5px 12px;
        color: #fff;
        background-color: green;
        border-radius: 5px;
        box-shadow: 0 0 7px #000;
      }

      &--viewTicket,
      &--copyTicket {
        display: flex;
        align-items: center;
        padding: 8px 24px;
        border: solid 1px;
        border-radius: 25px;
        cursor: pointer;
        font-family: $oscine-font-family, sans-serif;
        font-size: 16px;
      }

      &--viewTicket {
        color: #444;
      }

      &--copyTicket {
        color: #6320E9;
      }

      &--coverage,
      &--travel-date {
        display: inline-block;
        font-size: 16px;
        font-weight: 400;
      }
    }

    &__valuesBlockInfo {
      padding: 20px 16px 0;
      border-top: 1px solid #BDC2C6;
      margin-top: 20px;

      @media screen and (min-width: 768px) {
        padding: 24px 24px 0;
      }

      @media screen and (min-width: 1024px) {
        padding: 24px 32px 0;
      }
    }

    &__valuesInfo {
      display: flex;
      flex-flow: wrap;
      justify-content: space-between;

      &--name,
      &--details {
        display: flex;
        align-items: center;

        svg {
          width: 32px;
        }

        h2 {
          font-size: 18px;
          &:last-child {
            margin-left: 16px;
          }
        }
      }

      &--name {
        margin-right: 24px;
      }

      &--details h2 {
        font-size: 16px;
      }
    }

    &__valuesTotal {
      display: flex;
      justify-content: space-between;

      &--border-top {
        margin-top: 16px;
        padding-top: 16px;
        border-top: 1px solid #BDC2C6;
      }
    }
  }

  .success-page {
    &__header {
      h2 {
        color: #444444;
        font-size: 24px;
        line-height: 31px;
        margin-bottom: 24px;
        text-align: center;
      }

      p {
        color: #707070;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 40px;
        text-align: center;
      }
    }

    &__block {
      background-color: #FFFFFF;
      border: 1px solid rgba(189, 194, 198, 0.403163);
      box-sizing: border-box;
      border-radius: 8px;
      display: flex;
      flex-shrink: 0;
      flex-wrap: wrap;
      padding: 24px 32px;

      + .success-page__block {
        margin-top: 16px;
      }

      h3 {
        color: #444444;
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 32px;
        text-align: left;
        width: 100%;
      }

      span {
        &.icon {
          color: #444444;
          display: inline-block;
          font-family: $oscine-font-family, sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 18px;
          line-height: 23px;
          padding-left: 40px;
          position: relative;

          &__pix {
            &::before {
              background-image: url(~@/assets/icons/icon-pix-purple.svg);
              background-size: cover;
              content: '';
              height: 30px;
              left: 0;
              position: absolute;
              top: -3px;
              width: 30px;
            }
          }
        }
      }

      &__row {
        align-items: center;
        display: flex;
        justify-content: space-between;
        min-width: 100%;

        &.row-footer {
          border-top: solid 1px #BDC2C6;
          margin-top: 32px;
          padding-top: 32px;
        }
      }
    }
  }
</style>
